import { Component, Input } from '@angular/core';
import { DefaultFormDialogComponent } from '../../../../../shared/message/dialogs/default-form-dialog.component';
import { GaValidateService } from '../../../../../shared/formly/ga-validate.service';
import { TranslationService } from '../../../../../shared/translation/translation.service';
import { Override } from '../../../../../shared/app-decorators';
import { BPProfilesOEMDataService, IOEMDistributor, IOEMRelation } from '../bp-profiles-oem-data.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../../../shared/formly/ga-formly.service';
import { FormattingService } from '../../../../../shared/services/formatting.service';

export interface IAddDistributorModel {
  distributor?:IOEMDistributor;
  preferred?:boolean;
}

@Component({
  selector: 'oem-add-distributor-dialog',
  templateUrl: '../../../../../shared/message/dialogs/default-form-dialog.html'
})
export class OEMAddDistributorDialogComponent extends DefaultFormDialogComponent {
  @Input() public selectedOEM:IOEMRelation;
  public model:IAddDistributorModel;

  private distributorField:IExtraFieldConfigurationObject;

  constructor(
    private bpProfilesOEMDataService:BPProfilesOEMDataService,
    private formlyService:GaFormlyService,
    private formattingService:FormattingService,
    protected validateService:GaValidateService,
    protected translationService:TranslationService
  ) {
    super(validateService, translationService);
  }

  @Override(DefaultFormDialogComponent)
  public ngOnInit():void {
    super.ngOnInit();

    if (!this.selectedOEM?.distributors?.length) {
      this.model.preferred = true;
    }

    // create fields
    this.fields = this.createFields();
    // fill fields
    this.fillFields();
  }

  private fillFields():void {
    this.formlyService.fillField(this.distributorField, this.bpProfilesOEMDataService.getCountryDistributors(this.selectedOEM.distributors));
  }

  private createFields():IExtraFieldConfigurationObject[] {
    return [
      this.distributorField = this.formlyService.aNgSelect('distributor')
        .withFormat(this.formattingService.formatCompanyCountry)
        .withoutWrapper()
        .build(),
      this.formlyService.aCheckbox('preferred')
        .withoutWrapper()
        .withWrapperClass('col-12 mt-2')
        .build()
    ];
  }
}